import React, {Component} from 'react'
import {Upload, Icon, Modal, message, Button} from 'antd'
import {connect} from 'react-redux'

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

class FileInput extends Component {
  constructor (props) {
    super(props)
    // 添加uid
    let file = this.props.value || {}
    let fileList = file.fileName ? [{
      uid: -1,
      name: file.fileName,
      status: 'done',
      url: ''
    }] : []

    this.state = {
      previewVisible: false,
      previewImage: '',
      max: 1,
      fileList
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value.fileName) {
      let fileList = [{
        uid: -1,
        name: nextProps.value.fileName,
        status: 'done',
        url: ''
      }]
      this.setState({fileList})
    }
  }
  handleCancel = () => this.setState({previewVisible: false})
  // 点击文件链接或预览图标时的回调
  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    })
  }
  // 移除
  handleRemove = ({uid}) => {
    this.setState({fileList: []}, () => {
      const onChange = this.props.onChange
      if (onChange) {
        onChange(null)
      }
    })
    return true
  }
  // 上传中、完成、失败都会调用这个函数。 event上传中的服务端响应内容
  handleChange = ({file}) => {
    const {name, size, type, uid} = file
    let index = name.lastIndexOf('.')
    // 获取文件的 base64 格式
    getBase64(file, (imageUrl) => {
      imageUrl = imageUrl.slice(imageUrl.indexOf(',') + 1)
      const params = {
        file: imageUrl,
        fileType: name.slice(index + 1),
        fileName: name.slice(0, index)
      }
      const fileList = [{
        uid: -1,
        name: params.fileName,
        status: 'done',
        url: ''
      }]
      this.setState({fileList})

      // 自定义表单组件接口onChange
      const onChange = this.props.onChange
      if (onChange) {
        onChange(params)
      }
    })
  }
  beforeUpload = (file) => {
    const isLt3M = file.size / 1024 / 1024 < 3
    if (!isLt3M) {
      message.error('文件不能超过3MB!')
    }
    return isLt3M
  }
  render () {
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <Button>
        <Icon type="upload" /> Click to Upload
      </Button>
    )
    return (
      <div className="clearfix">
        {/* accept="image/*" // 接收上传的文件类型。 */}
        <Upload
          action="/index/upload"
          fileList={fileList} // 上传文件的列表
          customRequest={this.handleChange} // 自定义上传实现
          beforeUpload={this.beforeUpload} // 上传文件之前的钩子，参数为上传的文件，返回false 停止上传。
          onRemove={this.handleRemove} // 点击移除文件时的回调，返回值为 false 时不移除。
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
        <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel} width={970}>
          <div style={{textAlign: 'center', padding: '15px'}}>
            <img alt="example" style={{ maxWidth: '100%' }} src={previewImage} />
          </div>
        </Modal>
      </div>
    )
  }
}

export default FileInput


// WEBPACK FOOTER //
// ./src/components/common/FileInput/index.js